import React from 'react';
import { WorkflowTypeListComponent } from '@admin/shared';

const WorkflowTypeList = () => {
  return <WorkflowTypeListComponent />;
};

export { WorkflowTypeList };
